const parseTime = (time: string): { hours: number; minutes: number } | null => {
  if (!time) return null;
  const [hoursStr, minutesStr] = time.split(':');
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return { hours, minutes };
};

// Schedule times are the store's own local time, not an instant — never run
// them through the browser's timezone. The backend stores and returns the
// exact same local time back, so these only reformat between the native
// <input type="time"> shape (HH:mm) and the API's HH:mm:ss, with no
// UTC/local conversion in either direction.
export const toApiTime = (time: string): string => {
  const parsed = parseTime(time);
  if (!parsed) return time;
  const hh = String(parsed.hours).padStart(2, '0');
  const mm = String(parsed.minutes).padStart(2, '0');
  return `${hh}:${mm}:00`;
};

export const toInputTime = (time: string): string => {
  const parsed = parseTime(time);
  if (!parsed) return time;
  const hh = String(parsed.hours).padStart(2, '0');
  const mm = String(parsed.minutes).padStart(2, '0');
  return `${hh}:${mm}`;
};

export const formatTimeTo12Hour = (time: string): string => {
  const parsed = parseTime(time);
  if (!parsed) return time;
  const period = parsed.hours >= 12 ? 'PM' : 'AM';
  const hours12 = parsed.hours % 12 || 12;
  const mm = String(parsed.minutes).padStart(2, '0');
  return `${hours12}:${mm} ${period}`;
};

export const formatUTCDateTimeToLocal = (dateStr: string): string => {
  const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(dateStr);
  const normalized = hasTimezone ? dateStr : `${dateStr}Z`;
  return new Date(normalized).toLocaleString();
};
